const alignmentCards = new Set();
const cardWidths = new WeakMap();
let alignmentFrame;

function scheduleCardAlignment() {
  if (alignmentFrame) return;
  alignmentFrame = requestAnimationFrame(() => {
    alignmentFrame = null;
    const records = [];
    for (const card of alignmentCards) {
      const heading = card.querySelector('h2, h3');
      const title = heading?.closest('.product-card-group');
      const gallery = card.querySelector('product-card-media-gallery');
      if (!title || !gallery || !(title.compareDocumentPosition(gallery) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
      title.style.minHeight = '';
      title.style.flexShrink = '0';
      const footer = card.querySelector('product-price')?.closest('.product-card-group');
      const details = footer && footer !== title && (gallery.compareDocumentPosition(footer) & Node.DOCUMENT_POSITION_FOLLOWING) ? footer : null;
      if (details) {
        details.style.minHeight = '';
        details.style.flexShrink = '0';
        details.style.justifyContent = 'flex-start';
      }
      records.push({ card, title, details });
    }

    const rows = [];
    for (const record of records) {
      const rect = record.card.getBoundingClientRect();
      if (!rect.width || !rect.height) continue;
      const section = record.card.closest('.shopify-section') || record.card.parentElement;
      let row = rows.find(item => item.section === section && Math.abs(item.top - rect.top) < 4);
      if (!row) {
        row = { section, top: rect.top, items: [] };
        rows.push(row);
      }
      row.items.push({ title: record.title, height: record.title.getBoundingClientRect().height, details: record.details, detailsHeight: record.details?.getBoundingClientRect().height || 0 });
    }

    for (const row of rows) {
      if (row.items.length < 2) continue;
      const height = Math.ceil(Math.max(...row.items.map(item => item.height)));
      const detailsHeight = Math.ceil(Math.max(...row.items.map(item => item.detailsHeight)));
      for (const item of row.items) {
        item.title.style.minHeight = `${height}px`;
        if (item.details) item.details.style.minHeight = `${detailsHeight}px`;
      }
    }
  });
}

const cardResizeObserver = new ResizeObserver(entries => {
  let changed = false;
  for (const entry of entries) {
    const width = entry.contentRect.width;
    if (cardWidths.get(entry.target) !== width) {
      cardWidths.set(entry.target, width);
      changed = true;
    }
  }
  if (changed) scheduleCardAlignment();
});

document.fonts.ready.then(scheduleCardAlignment);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productUrl = null;
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;
    this.addEventListener('click', this.handleClick);
    alignmentCards.add(this);
    cardResizeObserver.observe(this);
    scheduleCardAlignment();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    alignmentCards.delete(this);
    cardResizeObserver.unobserve(this);
    scheduleCardAlignment();
  }

  handleClick(event) {
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest(
        'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
      );
      if (interactiveElement) return;
    }
    window.location.href = this.productUrl;
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
